import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import clamp from "../../../../../common/helpers/clamp";
import Filter from "../../../../../models/Filter";
import Btn from "../../../../../components/atoms/Btn";

function NumberFilter({ handleChange, filter, handleHighlight }) {
  const { id } = filter;
  const [val, setVal] = useState(filter.value);
  const inputRef = useRef(null);

  function applyFilter() {
    const num = parseFloat(val);
    const numberVal = Number.isNaN(num) ? filter.default : num;
    const fixedVal = clamp(numberVal, filter.min, filter.max);
    handleChange({ ids: [id], value: fixedVal });
  }

  useEffect(() => {
    setVal(filter.value);
  }, [filter.value]);

  return (
    <div className="tw-pt-3 tw-mt-2 tw-w-full tw-border-t tw-border-blueGray-400 tw-border-opacity-30">
      <div
        onMouseMove={() => handleHighlight(null, null)}
        className="color-1 tw-flex tw-justify-items-center tw-items-center"
      >
        <div className="tw-opacity-80 tw-flex-grow tw-min-w-28">
          {filter.label}
        </div>

        <div className="tw-px-1">
          <input
            type="text"
            ref={inputRef}
            className="tw-w-28 color-1 bg-1 tw-mr-2 tw-p-1"
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && applyFilter()}
          />
        </div>

        <Btn
          onSubmit={() => applyFilter()}
          className="tw-bg-blueGray-600 tw-p-1 tw-text-white tw-rounded"
        >
          Apply
        </Btn>
      </div>
    </div>
  );
}

NumberFilter.propTypes = {
  filter: PropTypes.instanceOf(Filter).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleHighlight: PropTypes.func.isRequired,
};

export default NumberFilter;
